import { render } from "./serviceDetail.vue?vue&type=template&id=57bae978&scoped=true"
import script from "./serviceDetail.vue?vue&type=script&lang=js"
export * from "./serviceDetail.vue?vue&type=script&lang=js"

import "./serviceDetail.vue?vue&type=style&index=0&id=57bae978&lang=less&scoped=true"

import exportComponent from "/Users/yiduolanghua/Desktop/edu/visitor-h5-jy/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-57bae978"]])

export default __exports__